import React from 'react';

import DefaultRedux from '../../../redux/defaultRedux';
import Config from '../../../shared/config/Configuration';
import Scrollable from '../../../shared/tools/Scrollable';

import styles from './MenuBar.module.scss';


let MenuBar = (props) => {
  const menuBarStyle = [styles.MenuBar];

  if(props.rs.showMenu) {
    menuBarStyle.push(styles.MenuBarOpened);
  }

  const onClickMenuItem = (section) => {
    props.rd.onShowMenu(false);
    Scrollable.scrollTo(section.id);
  }

  return (
    <div className={menuBarStyle.join(' ')}>
      <div className={styles.MenuItems}>
        {Config.sections.map(section => (
          <div key={section.title} className={styles.Item} onClick={() => onClickMenuItem(section)}>
            <section.icon className={styles.Icon}/>
            {section.title}
          </div>
        ))}
      </div>
    </div>
  );
}

MenuBar = DefaultRedux.connect(MenuBar);

export default MenuBar;
